type ReplaceUrlLocaleOptions = {
  url: URL
  locale: string
  currentLocale?: string
}

const replaceUrlLocale = ({ url, locale, currentLocale }: ReplaceUrlLocaleOptions): URL => {
  const response = new URL(url.href)
  const pathMatcher = new RegExp(`^/${currentLocale}(/|$)`)
  if (currentLocale == null || !url.pathname.match(pathMatcher)) {
    response.pathname = `/${locale}${url.pathname}`
  } else {
    response.pathname = `/${locale}${url.pathname.substring(currentLocale.length + 1)}`
  }
  return response
}

const replaceUrlUtmMedium = (url: string, utmMedium: string): string => {
  const newUrl = new URL(url, location.href)
  newUrl.searchParams.set('utm_medium', utmMedium)
  return newUrl.toString()
}

export { replaceUrlLocale, replaceUrlUtmMedium, ReplaceUrlLocaleOptions }
